import React from "react";

import { Picker } from "components";
import { useListQuestion } from "screens/question/hooks";
import { Images } from "utils/Images";
import {
  Container,
  Label,
  StyledTextInput,
  CarrotImage,
  LabelWrapper,
} from "./styled";

export const ListQuestion = ({ question }) => {
  const {
    options,
    onPress,
    selectedOption,
    isPickerVisible,
    setPickerVisible,
    placeholder,
    RTL,
  } = useListQuestion(question);

  const isFocused = isPickerVisible || selectedOption?.text;

  return (
    <Container isOpen={isPickerVisible}>
      <LabelWrapper onPress={() => setPickerVisible(!isPickerVisible)}>
        <Label $RTL={RTL} $isFocused={isFocused}>
          {placeholder}
        </Label>
        <StyledTextInput
          editable={false}
          $isFocused={isFocused}
          value={selectedOption?.text.replaceAll("*", "") || ""}
          onBlur={() => setPickerVisible(false)}
        />
        <CarrotImage $RTL={RTL} source={Images.Carret} />
      </LabelWrapper>
      {isPickerVisible && (
        <Picker
          visible={isPickerVisible}
          options={options}
          textKey="text"
          onPress={onPress}
          dismiss={() => setPickerVisible(false)}
          selectedOption={selectedOption}
          isThemeB={true}
        />
      )}
    </Container>
  );
};
